var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 35.25L8.625 20.5625L12.65 16.3031L20.125 23.9406V0H25.875V23.9406L33.35 16.3031L37.375 20.5625L23 35.25ZM5.75 47C4.16875 47 2.8151 46.4247 1.68906 45.2742C0.563021 44.1237 0 42.7406 0 41.125V32.3125H5.75V41.125H40.25V32.3125H46V41.125C46 42.7406 45.437 44.1237 44.3109 45.2742C43.1849 46.4247 41.8313 47 40.25 47H5.75Z",
    fill: "#0090D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.20f76b61f1c09853e482cf2dca9d8f38.svg";
export { ForwardRef as ReactComponent };